import { Badge, Button, Typography } from '@material-ui/core';

const TopNavButton = ({ onClick, badgeContent, icon, title }) => {
	return badgeContent ? (
		<Button
			className="px-0 w-72 hover:shadow hover:bg-transparent"
			onClick={onClick}
			style={{ minWidth: 'max-content' }}
		>
			<Badge
				anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
				badgeContent={badgeContent}
				className=""
				color="error"
				invisible={badgeContent === 0}
				overlap="circular"
			>
				<div className="flex flex-col items-center justify-center gap-0">
					<div className="flex justify-center">{icon}</div>
					<Typography className="font-bold normal-case text-pd-xs " variant="body1">
						{title}
					</Typography>
				</div>
			</Badge>
		</Button>
	) : (
		<Button
			className="px-0 w-72 hover:shadow hover:bg-transparent"
			onClick={onClick}
			style={{ minWidth: 'max-content' }}
		>
			<div className="flex flex-col items-center justify-center gap-0">
				<div className="w-32 sm:w-full flex justify-center">{icon}</div>
				<Typography className="font-bold normal-case text-pd-xs " variant="body1">
					{title}
				</Typography>
			</div>
		</Button>
	);
};

export default TopNavButton;
